/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */

import { Component } from '@angular/core';

@Component({
  selector: 'martmax-top-deals',
  templateUrl: './top-deals.component.html',
  styleUrls: ['./top-deals.component.css']
})
export class TopDealsComponent {
  public ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/top-deals/top-deals.component.ts